import { createAction } from '@ngrx/store';

export const spinnerOnDemand = createAction('[UI] Spinner on Demand');
